import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  artist: belongsTo('artist', { inverse: null }),
  backgroundImage: belongsTo('asset', { inverse: null }),
  backgroundVideo: belongsTo('asset', { inverse: null }),
  channel: belongsTo('channel', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsLockerId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  cmsOwnerId: belongsTo('user', { inverse: null }),
  favicon: belongsTo('asset', { inverse: null }),
  footerLinks: hasMany('link', { inverse: null }),
  headerArtistCustomLogo: belongsTo('asset', { inverse: null }),
  newsletter: belongsTo('newsletter', { inverse: null }),
  seoImage: belongsTo('asset', { inverse: null }),
  ownedByChannel: belongsTo('channel', { inverse: null }),
  pages: hasMany('mlp-page', { inverse: 'mlp' }),
  publishedMlp: belongsTo('mlp', { inverse: null }),
  relatedMlps: hasMany('mlp', { inverse: null }),
  shopifyStore: belongsTo('shopify-store', { inverse: null }),
  thumbnail: belongsTo('asset', { inverse: null }),
  vhost: belongsTo('vhost', { inverse: null }),
});
